import Bowser from "bowser";

const browser = Bowser.getParser(window.navigator.userAgent);
const platform = browser.getPlatform();
export const isMobile = platform.type === 'mobile';